export default __webpack_public_path__ + "static/media/05.57674c68.png";